import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import BreadcrumbsEntry from '../../common/breadcrumbs/BreadcrumbsEntry';
import BasicLayout from '../../layouts/BasicLayout';
import { css } from 'react-emotion';
import SkuTreeView from './SkuTreeView';
import { actions as termActions, selectors as terms } from '../../../reducers/terms';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { selectors as configurations } from '../../../reducers/configurations';
import ErrorRobot from '../../common/ErrorRobot';
import Loading from '../../Loading';
import ContractInfoForOneSku from './ContractInfoForOneSku';

const containerStyle = css({
  display: 'flex',
  flexDirection: 'column'
});

const contentStyle = css({
  display: 'flex'
});

const centerStyle = css({
  flex: '1'
});

export const INFO_TAB = 0;
export const PRICING_TAB = 1;

class ViewSkuPage extends Component {
  state = {
    selectedTerm: undefined,
    selectedTab: INFO_TAB,
    selectingTerm: false
  };

  componentDidMount() {
    const { match, fetchTermsBySku, fetchEffectiveTermsBySku } = this.props;
    fetchTermsBySku(match.params.sku);
    fetchEffectiveTermsBySku(match.params.sku);
  }

  componentDidUpdate(prevProps, prevState) {
    const { match, fetchTermsBySku, fetchEffectiveTermsBySku } = this.props;
    const sku = match.params.sku;

    if (prevProps.match.params.sku !== sku) {
      fetchTermsBySku(sku);
      fetchEffectiveTermsBySku(sku);
    }
  }

  onSelectTerm = selectedTerm => {
    const { fetchTermRevisionItemBySku } = this.props;

    this.setState({ selectedTerm, selectingTerm: true });
    const promises = [];
    promises.push(
      fetchTermRevisionItemBySku(selectedTerm.termId, selectedTerm.revisionId, this.props.match.params.sku)
    );
    promises.push(
      this.props
        .fetchLatestTermRevision(selectedTerm.termId)
        .then(latest => {
          if (selectedTerm.revisionId !== latest.revisionId) {
            return fetchTermRevisionItemBySku(
              selectedTerm.termId,
              selectedTerm.latestRevision.revisionId,
              this.props.match.params.sku
            );
          }
        })
        .catch(_ => {})
    );
    if (
      selectedTerm.effectiveTermRevision &&
      selectedTerm.effectiveTermRevision.revisionId !== selectedTerm.revisionId
    ) {
      promises.push(
        fetchTermRevisionItemBySku(
          selectedTerm.termId,
          selectedTerm.effectiveTermRevision.revisionId,
          this.props.match.params.sku
        )
      );
    }

    Promise.all(promises).then(() => this.setState({ selectingTerm: false }));
  };

  onTabSelected = selectedTab => {
    this.setState({ selectedTab });
  };

  render() {
    const sku = this.props.match.params.sku;
    const { t, termsByBuyer, showTerminated, isPageLoaded, isPageLoading, isPageLoadingFailed } = this.props;
    const { selectedTerm, selectedTab, selectingTerm } = this.state;

    /**
     * isLatest isLatestWithSku isEffective
     * 0        1               0             => Don't show to users. Should be filtered out in redux.
     * 0        1               1             => Let users know sku is being priced but sku was removed from later revision.
     * 1        1               0             => show latest.
     * 1        1               1             => show latest with effective flag.
     */

    return (
      <BreadcrumbsEntry title={{ translationKey: 'breadcrumbs:viewSku', data: { sku } }}>
        <BasicLayout title={t('investigateSku:contractsBySku.header', { sku })}>
          <div className={containerStyle}>
            <div className={contentStyle}>
              {isPageLoadingFailed || (isPageLoaded && isEmpty(termsByBuyer)) ? (
                <div className={centerStyle}>
                  <ErrorRobot msg={t('investigateSku:noContractsFound', { sku })} includeContact={false} />
                </div>
              ) : isPageLoading ? (
                <div className={centerStyle}>
                  <Loading />
                </div>
              ) : (
                <div style={{ width: '100%' }}>
                  <div className={'col-xs-12 col-md-5'}>
                    <h5>{t('investigateSku:contractsBySku.header2', { sku })}</h5>
                    {!isEmpty(termsByBuyer) && (
                      <SkuTreeView
                        sku={sku}
                        termsByBuyer={termsByBuyer}
                        onSelectTerm={this.onSelectTerm}
                        selectedTerm={selectedTerm}
                        showTerminated={showTerminated}
                      />
                    )}
                  </div>
                  <div className="col-xs-12 col-md-7" style={{ position: 'sticky', top: 0 }}>
                    {selectingTerm ? (
                      <Loading />
                    ) : (
                      <ContractInfoForOneSku
                        termRevision={selectedTerm}
                        sku={sku}
                        selectedTab={selectedTab}
                        onTabSelected={this.onTabSelected}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </BasicLayout>
      </BreadcrumbsEntry>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const sku = ownProps.match.params.sku;

  return {
    termsByBuyer: terms.getTermsByBuyers(state, sku),
    showTerminated: configurations.getShowTerminated(state),
    isPageLoading: terms.getIsSkuPageLoading(state),
    isPageLoaded: terms.getIsSkuPageLoaded(state),
    isPageLoadingFailed: terms.getIsSkuPageFailed(state)
  };
}

const mapDispatchToProps = {
  fetchTermsBySku: termActions.fetchTermsBySku,
  fetchLatestTermRevision: termActions.fetchLatestTermRevision,
  fetchEffectiveTermsBySku: termActions.fetchEffectiveTermsBySku,
  fetchTermRevisionItemBySku: termActions.fetchTermRevisionItemBySku
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ViewSkuPage));
